
import { reactive } from 'vue';

import { storedRef } from './utils.js';

import themePaths from '../images/activity-5-theme-*.png';

const activity = 5;

export const posterThemes = [ {

  id: 1,

  label: 'Life at Lewis and how African Americans experienced Shenandoah National Park during the Jim Crow era.'

}, {

  id: 2,

  label: 'The history of Civil Rights in America, using Shenandoah as an example.'

}, {

  id: 3,

  label: 'Social change through the lens of segregation and desegregation in Shenandoah National Park.'

} ].map( obj => ( { ...obj, path: themePaths[ obj.id ] } ) );

export const posterTheme = storedRef( activity, 'poster-theme', 1 );

export const posterStyles = reactive( [ {

  id: 1,

  headerImagePath: storedRef( activity, 'poster-style-1-header-image-path' ),

  title: storedRef( activity, 'poster-style-1-title' ),

  subtitle: storedRef( activity, 'poster-style-1-subtitle' ),

  paragraph1: storedRef( activity, 'poster-style-1-paragraph-1' ),

  paragraph2: storedRef( activity, 'poster-style-1-paragraph-2' ),

  sideImage1Path: storedRef( activity, 'poster-style-1-side-image-1-path' ),

  sideImage1Caption: storedRef( activity, 'poster-style-1-side-image-1-caption' ),

  sideImage2Path: storedRef( activity, 'poster-style-1-side-image-2-path' ),

  sideImage2Caption: storedRef( activity, 'poster-style-1-side-image-2-caption' )

}, {

  id: 2,

  topImage1Path: storedRef( activity, 'poster-style-2-top-image-1-path' ),

  topImage1Caption: storedRef( activity, 'poster-style-2-top-image-1-caption' ),

  topImage2Path: storedRef( activity, 'poster-style-2-top-image-2-path' ),

  topImage2Caption: storedRef( activity, 'poster-style-2-top-image-2-caption' ),

  subtitle: storedRef( activity, 'poster-style-2-subtitle' ),

  title: storedRef( activity, 'poster-style-2-title' ),

  paragraph: storedRef( activity, 'poster-style-2-paragraph' ),

  bottomImagePath: storedRef( activity, 'poster-style-2-bottom-image-path' ),

  bottomImageCaption: storedRef( activity, 'poster-style-2-bottom-image-caption' ),

}, {

  id: 3,

  title: storedRef( activity, 'poster-style-3-title' ),

  subtitle: storedRef( activity, 'poster-style-3-subtitle' ),

  quote: storedRef( activity, 'poster-style-3-quote' ),

  citation: storedRef( activity, 'poster-style-3-citation' ),

  topImagePath: storedRef( activity, 'poster-style-3-top-image-path' ),

  bottom1ImagePath: storedRef( activity, 'poster-style-3-bottom-image-1-path' ),

  bottom1ImageTitle: storedRef( activity, 'poster-style-3-bottom-image-1-title' ),

  bottom1ImageCaption: storedRef( activity, 'poster-style-3-bottom-image-1-caption' ),

  bottom2ImagePath: storedRef( activity, 'poster-style-3-bottom-image-2-path' ),

  bottom2ImageTitle: storedRef( activity, 'poster-style-3-bottom-image-2-title' ),

  bottom2ImageCaption: storedRef( activity, 'poster-style-3-bottom-image-2-caption' )

} ] );

export const posterStyle = storedRef( activity, 'poster-style', 1 );

export const seenPlayerDialog = storedRef( activity, 'seen-player-dialog', false );

export const hasDownloaded = storedRef( activity, 'has-downloaded', false );
